import React from 'react'

function Realtimemail() {
  return (
    <div>Realtimemail</div>
  )
}

export default Realtimemail